import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(
    @Inject('API_ENDPOINT') private apiUrl: string,
    private http: HttpClient
  ) { }

  getEndpoint() {

    return this.apiUrl;

  }

  upload(action: string, data: any, fileName: string, othersParams = {}, otherOptions = {}) {

    const options = {
      ...otherOptions,
      params: {
        action,        
        ...othersParams
      }
    }

    const formData: FormData = new FormData();
    formData.append(fileName, data, fileName);
    
    return this.http
      .post(`${this.apiUrl}`, formData, options)
      

  }

}
